export type AppRoute =
  | { kind: 'home' }
  | { kind: 'projects' }
  | { kind: 'project'; slug: string }
  | { kind: 'about' }
  | { kind: 'story' };

export function parseRoute(pathname = window.location.pathname): AppRoute {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  if (normalized === '/') return { kind: 'home' };
  if (normalized === '/projects') return { kind: 'projects' };
  if (normalized === '/about') return { kind: 'about' };
  if (normalized === '/story') return { kind: 'story' };

  const match = normalized.match(/^\/projects\/([a-z0-9][a-z0-9-]{0,62})$/i);
  if (match) return { kind: 'project', slug: match[1].toLowerCase() };
  return { kind: 'home' };
}

export function routePath(route: AppRoute): string {
  switch (route.kind) {
    case 'home':
      return '/';
    case 'projects':
      return '/projects';
    case 'project':
      return `/projects/${encodeURIComponent(route.slug)}`;
    case 'about':
      return '/about';
    case 'story':
      return '/story';
  }
}

export function navigate(route: AppRoute, replace = false): void {
  const path = routePath(route);
  if (window.location.pathname === path) return;
  window.history[replace ? 'replaceState' : 'pushState']({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
